/**
    Returns the squared euclidean distance between two points.
    @param p1 The first point, which should always be an `[x, y]` formatted Array.
    @param p2 The second point, which should always be an `[x, y]` formatted Array.
*/ export default function(p1, p2) {
    var dx = p2[0] - p1[0], dy = p2[1] - p1[1];
    return dx * dx + dy * dy;
}

//# sourceMappingURL=pointDistanceSquared.js.map